

import { forwardRef } from "react";

// prop-types is a library for typechecking of props

import MDBoxRoot from "./MDBoxRoot";
// Custom styles for MDBox
const MDBox = forwardRef(
  (
    {
      variant,
      bgColor,
      color,
      opacity,
      borderRadius,
      shadow,
      coloredShadow,
      ...rest
    }: any,
    ref
  ) => (
    <MDBoxRoot
      {...rest}
      ref={ref}
      ownerState={{
        variant,
        bgColor,
        color,
        opacity,
        borderRadius,
        shadow,
        coloredShadow,
      }}
    />
  )
);

export default MDBox;
